import { ifCanPushDatalayer } from "./utils/utils.dataLayer.common";
import categorizeMarketoFormSubmission from "./form-categorize-submission.common";

//UCS005
const dataLayerFormContactUs = (userStatus, userEmail, marketoIDF) => {
    ifCanPushDatalayer({
        then: () => {
            const formID = document.querySelector("[data-form-id]")?.dataset?.formId
            if (formID === "contact_us") {
                if (userEmail) {
                    categorizeMarketoFormSubmission({
                        userEmail,
                        userStatus,
                        leadType: "contact us",
                        marketoIDF
                    });
                }
            }
        },
    });
};

export default dataLayerFormContactUs;
